module.exports = __webpack_public_path__ + "img/Waste removed.81a86ef0.png";